<template lang="html">
  <div class="main-container">
    <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
     <tl-tabs :tabs="tabs" class="margintop-40">
          <tl-tab>
              <payments-taxes/>
          </tl-tab>
          <tl-tab>
              <employee-list/>
          </tl-tab>
      </tl-tabs>
 </div>
</template>

 <script>
import { mapState, mapActions, mapGetters } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import PaymentsTaxes from "./payments_taxes.vue";
import EmployeeList from "./employeesList.vue";
export default {
  components: {
    SearchDropdown,
    PaymentsTaxes,
    EmployeeList
  },
  data() {
    return {
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "IT Remittence",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/itremittence`
              }
        ],
      tabs: [
        {
          header: "Payment & Taxes"
        },
        {
          header: "Employee List"
        }
      ]
    };
  },
  methods: {
    routeToSubStep(sub_step_name) {
      this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/organisation/${sub_step_name}` });
    },
    routeToMainStep(main_step_name) {
      this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/${main_step_name}` });
    }
  }
};
</script>

 <style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section
.nav {
  margin-top: 1.7%;
  color: #555555;
  font-size: 11px;
}
.empName label {
  font-size: 16px;
  color: #646464;
  margin-bottom: 4px;
}
.position-fixed {
  position: fixed;
}
.empcode label {
  font-size: 14px;
  color: #878787;
}

.main-header {
  color: #6d6d6d;
  margin-top: 37px;
  font-size: 16px;
}
.upload {
  grid-row: span 2;
  width: 300px;
  line-height: 7px;
}
.half-width {
  width: 26.7%;
}
.search-bar input {
  height: 35px !important;
}
.filters-section {
  display: flex;
  align-items: flex-start;
  margin-top: 30px;
  // overflow: scroll;
  *:not(:last-child) {
    margin-right: 18px;
  }
}
.ver-line {
  border-right: solid 1px #30b6bc;
  padding-top: 10px;
}
.emp-img {
  width: auto;
  text-align: center;
}
.component-wrapper {
  padding: 14px;
}
.custom-width-100 {
  width: 100px;
}

.selectdiv {
  width: 320px !important;
  .input-label {
    opacity: 0.5 !important;
  }
}
.filters-button {
  margin-top: 10px;
  width: 95px;
  height: 35px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 4px;
  color: #555555;
  border: 1px solid #37c6c0;
}
.search-bar {
  padding: 30px 0px 30px 0px;
  display: flex;
}
.essStatus {
  margin: 2% 0 2% 0;
  display: flex;
}

.sort-by {
  display: flex;
  margin-left: 1%;

  span {
    margin-right: 10px;
    margin-top: 10px;
    color: #b3b3b3;
    font-size: 12px;
  }
}
.side-actions {
  margin-left: 10px;
  margin-top: 10px;
  img {
    cursor: pointer;
    margin-right: 5px;
    margin-left: 5px;
  }
}
.ht-35 {
  .tl-textfield input,
  select {
    height: 30px !important;
  }
}
.employee-cards {
  padding: 30px 0 0 10px;
}
.group-btn {
  margin: 40px 0px;
}
.search-container {
  width: auto;
}
// .search-bar{
//     position: relative;
// }
.search-result {
  position: absolute;
  width: 320px;
  background: #ffffff;
  max-height: 368px;
  border-radius: 4px;
  border: solid 1px #f7f7f7;
  overflow: auto;
  li {
    padding: 15px;
    border-bottom: 0.5px solid #e3e3e3;
    margin-right: 0px !important;
    &:hover {
      background-color: #d6f2f2;
    }
  }
}
.threeColumnGrid {
  grid-column-gap: 0px;
}
.img-part {
  img {
    width: 100%;
  }
}
</style>
